<template>
	<div style='padding:15px;'>
		<div @click="$router.go(-1)" style="cursor:pointer; float:right;"><i class="fas fa-arrow-circle-left fa-2x" style="color:deepskyblue;"></i></div>
		<div style="margin-bottom:2em;">
			<div>
				<div>
					<p>Tiers : <a :href="'/detailsTiers/'+infosTiers.id">{{ infosTiers.name }}</a></p>
					<p>Commande n° {{  }} du {{}}</p>
					<p>Référence client : {{  }}</p>
					<p>Affecté à : {{  }}</p>
					<p>Condition de règlement : {{  }}</p>
					<p>Mode de règlement : {{  }}</p>
					<p>Commentaire : {{  }}</p>
				</div>
				<div>

				</div>
				<div>
					<p>Statut du devis : {{}}</p>
					<p>Nom du fichier : {{}} <a v-on:click.stop="visualDevisTiers(data.item)"><span style="cursor:pointer;" class='far fa-eye' v-b-tooltip.hover title='Visualiser'></span></a></p>
					<el-button type="primary">Valider le devis</el-button>
				</div>
			</div>
			<el-form ref="form" :model="formPropal" label-position="top" id="formPropal">
				<div id="infoDevis">
					<el-form-item class="no-padding col-md-9">
						<el-select class="inline-input" v-model="formPropal.socid" clearable filterable remote reserve-keyword placeholder="Rechercher un tiers ..." :remote-method="remoteMethod" :loading="loading" @clear="clearSelectTiers" @change="handleSelect">
							<el-option v-for="item in tiers" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="Référence de la proposition">
						<el-input v-model="formPropal.refClient"></el-input>
					</el-form-item>
				</div>
				<div id="infoProduit">
					<el-form-item label="Activity zone">
						<el-select v-model="form.region" placeholder="please select your zone">
						<el-option label="Zone one" value="shanghai"></el-option>
						<el-option label="Zone two" value="beijing"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="Activity time">
						<el-col :span="11">
						<el-date-picker type="date" placeholder="Choisissez une date" v-model="form.date1" style="width: 100%;"></el-date-picker>
						</el-col>
						<el-col class="line" :span="2">-</el-col>
						<el-col :span="11">
						<el-time-picker placeholder="Pick a time" v-model="form.date2" style="width: 100%;"></el-time-picker>
						</el-col>
					</el-form-item>
					<el-form-item label="Instant delivery">
						<el-switch v-model="form.delivery"></el-switch>
					</el-form-item>
					<el-form-item label="Activity type">
						<el-checkbox-group v-model="form.type">
						<el-checkbox label="Online activities" name="type"></el-checkbox>
						<el-checkbox label="Promotion activities" name="type"></el-checkbox>
						<el-checkbox label="Offline activities" name="type"></el-checkbox>
						<el-checkbox label="Simple brand exposure" name="type"></el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="Resources">
						<el-radio-group v-model="form.resource">
						<el-radio label="Sponsor"></el-radio>
						<el-radio label="Venue"></el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="Activity form">
						<el-input type="textarea" v-model="form.desc"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">Créer Brouillon</el-button>
						<el-button type="danger" @click="resetForm('formPropal')">Annuler</el-button>
					</el-form-item>
				</div>
			</el-form>
		
		<!-- <b-form @submit.prevent="createPropal" id="formPropal">
			<div id="infoDevis">
			<label for="refClient">Nom de la proposition</label>
			<b-form-input type="text" placeholder="Titre de la proposition" v-model="form.refClient" required/>
			<div v-if="!isTiers">
				<label>Tiers*</label>
				<model-select :options="optionsTiers" v-model="form.socid" placeholder="Chercher un tiers" v-on:change="detailsTiers(form.socid)"></model-select>
			</div>
			<label for="date">Date*</label>
			<datepicker required name="date" v-model="form.selectedDate" :language="fr" placeholder="Choisir une date"></datepicker>
			<label for="selectConditionsPayment">Conditions de règlement*</label>
			<b-form-select required select-size="1" name="selectConditionsPayment" :options="optionsConditionsPayment" v-model="form.selectedConditionsPayment"></b-form-select>
			<label for="selectPayment">Mode de règlement*</label>
			<b-form-select required select-size="1" name="selectPayment" :options="optionsPayment" v-model="form.selectedPayment"></b-form-select>
			<label for="selectDeliveryDelay">Délai de livraison*</label>
			<b-form-select required select-size="1" name="selectDeliveryDelay" :options="optionsDeliveryDelay" v-model="form.selectedDeliveryDelay"></b-form-select>
			<label for="selectModelPdf">Modèle de document*</label>
			<b-form-select required select-size="1" name="selectModelPdf" :options="optionsModelPdf" v-model="form.selectedModel"></b-form-select>
			</div>
			<div id="infoProduit">
			<b-table :items="products" :fields="fieldsProducts" show-empty>
				<template v-slot:cell(description)="data">
				<span>{{ data.item.ref+" - "+data.item.label }}</span>
				<p v-if="data.item.start != '' && data.item.finish != ''">Du <datepicker disabled v-model="data.item.start" :language="fr"></datepicker> au <datepicker disabled v-model="data.item.finish" :language="fr"></datepicker></p>
				</template>
				<template v-slot:cell(tva)="data">
				<span>{{ data.item.tva+" %" }}</span>
				</template>
				<template v-slot:cell(prixUnitaire)="data">
				<span>{{ data.item.prixUnitaire }}</span>
				</template>
				<template v-slot:cell(qty)="data">
				<span>{{ data.item.qty }}</span>
				</template>
				<template v-slot:cell(reduction)="data">
				<span>{{ data.item.reduction}}</span>
				</template>
				<template v-slot:cell(totalHT)="data">
				<span>{{ data.item.qty*data.item.prixUnitaire }}</span>
				</template>
				<template v-slot:cell(edit)>
				<span><i class="fas fa-edit" style="cursor:pointer;"></i></span>
				</template>
				<template v-slot:cell(del)="data">
					<span><i class="fas fa-times" v-on:click="deleteProducts(data.item)" style="cursor:pointer;"></i></span>
				</template>   
			</b-table>
			<label for="selectTypeLine">Type de ligne à ajouter</label>
			<b-form-select select-size="1" id="selectTypeLine" name="selectTypeLine" :options="typeLine" v-model="selectedTypeLine"></b-form-select>
			<div v-if="selectedTypeLine == 1 ">
				<label for="selectType">Type</label>
				<b-form-select select-size="1" id="selectType" name="selectType" :options="productType" v-model="selectedProductType"></b-form-select>
				<b-table :items="product" id="tableProduct" :fields="fieldsProduct">
				<template v-slot:cell(description)="data">
					<wysiwyg v-model="data.item.label" id="descriptionProduct"/>
				</template>
				<template v-slot:cell(tva)="data">
					<b-form-select select-size="1" name="selectLine" :options="tauxTva" v-model="data.item.tva"></b-form-select>
				</template>
				<template v-slot:cell(prixUnitaire)="data">
					<b-form-input type="text" v-model="data.item.prixUnitaire"></b-form-input>
				</template>
				<template v-slot:cell(qty)="data">
					<b-form-input type="text" v-model="data.item.qty"></b-form-input>
				</template>
				<template v-slot:cell(reduction)="data">
					<b-form-input type="text" v-model="data.item.reduction"></b-form-input>
				</template>
				<template v-slot:cell(add)="data">
					<span v-if="data.item.qty > 0 && data.item.prixUnitaire != '' && data.item.description != ''"><i class="fas fa-plus" v-on:click="addProduct(data.item)" style="cursor:pointer;"></i></span>
				</template>
				<template v-slot:cell(del)="data">
					<span><i class="fas fa-times" v-on:click="deleteProduct(data)" style="cursor:pointer;"></i></span>
				</template>
				</b-table>
				<div v-if="selectedProductType == 1">
				<p>Si produit de type service à durée limitée:</p>
				<span>Du</span><datepicker v-model="limitedService.start" :language="fr" placeholder="Choisir une date"></datepicker>
				<span>Au</span><datepicker v-model="limitedService.finish" :language="fr" placeholder="Choisir une date"></datepicker>
				</div>
			</div>
			<div v-else>
				<vue-bootstrap-typeahead :data="optionsProducts" v-model="productSearch" size="lg" :serializer="s => s.text" placeholder="Chercher un produit ou un service" v-on:hit="chooseProduct($event)"/>
				<b-table :items="product" :fields="fieldsProduct" id="tableProduct" show-empty>
				<template v-slot:cell(description)="data">
					<span>{{ data.item.label }}</span>
				</template>
				<template v-slot:cell(tva)="data">
					<span>{{ data.item.tva+" %" }}</span>
				</template>
				<template v-slot:cell(prixUnitaire)="data">
					<span>{{ data.item.prixUnitaire }}</span>
				</template>
				<template v-slot:cell(qty)="data">
					<b-form-input type="text" v-model="data.item.qty"></b-form-input>
				</template>
				<template v-slot:cell(reduction)="data">
					<b-form-input type="text" v-model="data.item.reduction"></b-form-input>
				</template>
				<template v-slot:cell(add)="data">
					<span v-if="data.item.qty > 0 && data.item.prixUnitaire != '' && data.item.description != ''" ><i class="fas fa-plus" v-on:click="addProduct(data.item)" style="cursor:pointer;"></i></span>
				</template>
				<template v-slot:cell(del)="data">
					<span><i class="fas fa-times" v-on:click="deleteProduct(data)" style="cursor:pointer;"></i></span>
				</template> 
				</b-table>
				<div>
				<p>Si produit de type service à durée limitée:</p>
				<span>Du</span><datepicker v-model="limitedService.start" :language="fr" placeholder="Choisir une date"></datepicker>
				<span>Au</span><datepicker v-model="limitedService.finish" :language="fr" placeholder="Choisir une date"></datepicker>
				</div>
			</div>
			</div>
			<div v-if="products.length == 0 || form.socid == null" class="actionBarPropal">
			<b-button type="submit" variant="primary" disabled>Créer brouillon</b-button>
			</div>
			<div v-else class="actionBarPropal">
			<b-button type="submit" variant="primary">Créer brouillon</b-button>
			</div>
		</b-form> -->
		</div>
	</div>  
</template>

<script>
import fr from '../../../../../node_modules/vuejs-datepicker/dist/locale/translations/fr.js';
import Datepicker from 'vuejs-datepicker';
import script from '../../../../script/script.js';
import scriptTiers from '../../../../script/script_tiers.js';
import { ModelSelect } from 'vue-search-select'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import scriptCds from '../../../../script/script_cds'

export default {
  data () {
    return {
		fr: fr,
		isTiers: false,
		tiers: [],
		infosTiers: [],
		optionsModelPdf: [{value: 'azur', text: 'azur'}],
		optionsPayment: [],
		optionsConditionsPayment: [],
		optionsDeliveryDelay: [],
		optionsTiers: [],
		formPropal:{
			refClient: '',
			socid: null,
			selectedDate: new Date(),
			selectedDeliveryDelay: null,
			selectedConditionsPayment: '14',
			selectedPayment: null,
			selectedModel: 'azur'
		},
		form: {
			refClient: '',
			socid: null,
			selectedDate: new Date(),
			selectedDeliveryDelay: null,
			selectedConditionsPayment: '14',
			selectedPayment: null,
			selectedModel: 'azur'
		},
		selectedTypeLine: '1',
		typeLine: [
			{value: '1', text: 'Libre'},
			{value: '2', text: 'Prédéfini'}
		],
		selectedProductType: 0,
		productType: [
			{value: 0, text: 'Produit'},
			{value: 1, text: 'Service'}
		],
		product: [
			{
			id: '',
			ref: '',
			label: '',
			description: '',
			tva: '20.000',
			prixUnitaire: '',
			qty: '1',
			reduction: ''
			}
		],
		products: [],
		optionsProducts: [],
		productSearch: '',
		fieldsProduct: [
			{label: 'Description', key:'description',class:'descriptionProduct'},
			{label: 'TVA', key:'tva',class:'tvaProduct'},
			{label: 'P.U HT', key:'prixUnitaire',class:'prixProduct'},
			{label: 'Quantité', key:'qty',class:'qtyProduct'},
			{label: 'Réduction', key:'reduction',class:'reducProduct'},
			{label: '', key: 'add'},
			{label: '', key: 'del'}
		],
		fieldsProducts: [
			{label: 'Description', key:'description'},
			{label: 'TVA', key:'tva'},
			{label: 'P.U HT', key:'prixUnitaire'},
			{label: 'Quantité', key:'qty'},
			{label: 'Réduction', key:'reduction'},
			{label: 'Total HT', key:'totalHt'},
			{label: '', key: 'edit'},
			{label: '', key: 'del'}
		],
		tauxTva: [
			{value: '20.000', text: '20'},
			{value: '10.000', text: '10'},
			{value: '5.500', text: '5.5'},
			{value: '0', text: '0'}
		],
		editor: ClassicEditor,
		editorConfig:{
			
		},
		limitedService: {
			start: '',
			finish: ''
		},
		editorOption: {
			modules: {
			toolbar: '#toolbar'
			}
		},
		loading: false  
	}
  },
  methods: {
    detailsTiers: scriptTiers.detailsTiers,
    loadingDictionary: scriptTiers.loadingDictionary,
    createPropal: script.createPropal,
    loadingClient: scriptTiers.loadingClient,
    verifyTiers () {
		if(this.$route.params.id!=null){
			this.detailsTiers(this.$route.params.id)
			this.isTiers = true
			this.form.socid = this.$route.params.id
		}
    },
    searchProducts: script.searchProducts,
    addProduct: script.addProduct,
    chooseProduct: script.chooseProduct,
    deleteProduct: script.deleteProduct,
	deleteProducts: script.deleteProducts,
	searchTiers: scriptCds.searchTiers,
	remoteMethod(queryString) {
		if (queryString !== '') {
			this.loading = true;
			setTimeout(() => {
				this.searchTiers(queryString)
				this.loading = false;
			}, 200);
		} else {
			this.tiers = [];
		}
	},
	handleSelect(evt){
		if(evt != ''){
			this.detailsTiers(evt)
			this.form.socid = evt
		}
	},
	resetForm(form) {
		this.$refs[form].resetFields();
	},
	clearSelectTiers(){
		this.form.socid = null
		this.infosTiers = []
	},
	visualDevisTiers: scriptTiers.visualDevisTiers
  },
  watch: {
    "productSearch": function () {
      this.searchProducts(this.productSearch)
    }
  },
  mounted: function () {
    this.verifyTiers(),
    this.loadingDictionary()
  },
  components: {
    Datepicker,
    ModelSelect
  }
}
</script>

<style scoped>
#infoDevis{
  flex: 1 1 45%;
  margin-right: 5%;
}

#infoProduit{
  flex: 1 1 45%;
}

#tableProduct >>> .descriptionProduct{
  width: 20em;
  max-width: 20em;
}

#tableProduct >>> .prixProduct{
  width: 8em;
  max-width: 8em;
}

#tableProduct >>> .tvaProduct{
  width: 6em;
  max-width: 6em;
}

#tableProduct >>> .qtyProduct{
  width: 8em;
  max-width: 8em;
}

#tableProduct >>> .reducProduct{
  width: 6em;
  max-width: 6em;
}

#selectType{
  margin-bottom: 1em;
}

#selectTypeLine{
  margin-bottom: 1em;
}

#formPropal{
  display: flex;
}

.actionBarPropal{
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  text-align: end;
  padding: 1em;
  background: white;
}
</style>
